/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SearchLoupePlusIcon16Light } from './SearchLoupePlusIcon16Light';
import { SearchLoupePlusIcon16Regular } from './SearchLoupePlusIcon16Regular';
import { SearchLoupePlusIcon16Solid } from './SearchLoupePlusIcon16Solid';
import { SearchLoupePlusIcon20Light } from './SearchLoupePlusIcon20Light';
import { SearchLoupePlusIcon20Regular } from './SearchLoupePlusIcon20Regular';
import { SearchLoupePlusIcon20Solid } from './SearchLoupePlusIcon20Solid';
import { SearchLoupePlusIcon24Regular } from './SearchLoupePlusIcon24Regular';
import { SearchLoupePlusIcon24Solid } from './SearchLoupePlusIcon24Solid';
import { SearchLoupePlusIcon32Regular } from './SearchLoupePlusIcon32Regular';
import { SearchLoupePlusIcon64Regular } from './SearchLoupePlusIcon64Regular';
var sizes = {
    16: {
        light: SearchLoupePlusIcon16Light,
        regular: SearchLoupePlusIcon16Regular,
        solid: SearchLoupePlusIcon16Solid,
    },
    20: {
        light: SearchLoupePlusIcon20Light,
        regular: SearchLoupePlusIcon20Regular,
        solid: SearchLoupePlusIcon20Solid,
    },
    24: {
        regular: SearchLoupePlusIcon24Regular,
        solid: SearchLoupePlusIcon24Solid,
    },
    32: {
        regular: SearchLoupePlusIcon32Regular,
    },
    64: {
        regular: SearchLoupePlusIcon64Regular,
    },
};
export var SearchLoupePlusIcon = forwardRef('SearchLoupePlusIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
